module.exports = __webpack_public_path__ + "img/miraimon.453da0fa.jpg";